import * as Cookies from 'js-cookie';
import acfFields from 'acfFields';

export default {
  init() {
    // JavaScript to be fired on the home page
    const form = document.querySelector('.listing__aside__container')
    const listingNavMobile = document.querySelector('.nav--listing--mobile')
    const listingNavDesktop = document.querySelector('.nav--listing--desktop')
    const revealButtons = document.querySelectorAll('.js-reveal-meta')
    const listingDataSections = document.querySelectorAll('.listing__meta')
    const selectReveal = document.querySelector('.js-select-reveal')
    const listingAmenities = document.querySelector('.listing__amenities')
    const listingGallery = document.querySelector('.listing__gallery')
    const listingAmenitiesRow = document.querySelectorAll('.listing__amenities__row')
    const listingGalleriesRow = document.querySelectorAll('.listing__gallery__row')
    const listingAmenitiesReveal = document.querySelector('.js-reveal-amenities')
    const listingGalleriesReveal = document.querySelector('.js-reveal-galleries')
    const revealHide = document.querySelectorAll('.js-reveal-hide')
    let activeAnchor = document.querySelector('.menu-item.is-active')
    //const navListingItems = document.querySelectorAll('.nav--listing--desktop li')
    // JavaScript to be fired on the home page
    const jsPopup = document.querySelector('.js-popup')

    // Update fancybox buttons with ADA in mind
    const fancyboxBtns = {
      download:
      '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;" aria-labelledby="download">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg>' +
      '<span id="download" hidden>Download</span>' +
      '</a>',

      zoom:
      '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}" aria-labelledby="zoom">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg>' +
      '<span id="zoom" hidden>Zoom</span>' +
      '</button>',

      close:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}" aria-labelledby="close">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg>' +
      '<span id="close" hidden>Close</span>' +
      '</button>',

      // Arrows
      arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" aria-labelledby="previous">' +
      '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div>' +
      '<span id="previous" hidden>Previous</span>' +
      '</button>',

      arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" aria-labelledby="next">' +
      '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div>' +
      '<span id="next" hidden>Next</span>' +
      '</button>',

      // This small close button will be appended to your html/inline/ajax content by default,
      // if "smallBtn" option is not set to false
      smallBtn:
      '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}" aria-labelledby="close">' +
      '<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg>' +
      '<span id="close" hidden>Close</span>' +
      '</button>',
    }

    /**
    * Sticky
    */
    class Sticky {
      /**
      * Initialize making an element sticky
      *
      * @param {object} element The element that will get a sticky state
      */
      constructor(element) {
        this.element = element
        this.elementTop = this.element.getBoundingClientRect().top

        window.addEventListener('scroll', this.onScroll.bind(this))
      }

      /**
      * Start the sticky state if condition is true
      *
      * @return {boolean} The windows scrollY position is greater or equal to the elements position relative to the viewport
      */
      startStickyState() {
        return window.scrollY >= this.elementTop
      }

      /**
      * Set the form state
      *
      * @param {object} event
      */
      onScroll(event) {
        if (this.startStickyState()) {
          this.stickyState()
        } else {
          this.staticState()
        }
      }

      /**
      * Set form to sticky state
      */
      stickyState() {
        this.element.classList.add('is-sticky')
      }

      /**
      * Set form to static state
      */
      staticState() {
        this.element.classList.remove('is-sticky')
      }
    }

    // Elements that will get a sticky state
    if (window.matchMedia('(min-width: 1024px)').matches) {
      new Sticky(form)

      new Sticky(listingNavDesktop)
    } else {
      new Sticky(listingNavMobile)
    }

    // Reveal / Hide listing data sections on click
    if (revealButtons) {
      revealButtons.forEach(revealButton => {
        revealButton.addEventListener('click', function (e) {
          e.preventDefault()

          activeAnchor.classList.remove('is-active')

          if (this.parentElement !== activeAnchor) {
            activeAnchor = this.parentElement

            activeAnchor.classList.add('is-active')
          }

          let currentAnchor = this.dataset.section

          listingDataSections.forEach(listingDataSection => {
            const metaID = `#${listingDataSection.getAttribute('id')}`

            if (currentAnchor == metaID) {
              listingDataSection.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })

              return
            }
          })
        })
      })
    }

    // Reveal / Hide listing data sections on select change
    if (selectReveal) {
      selectReveal.addEventListener('change', function (e) {
        e.preventDefault()

        const currentOption = `#${this.value}`

        listingDataSections.forEach(listingDataSection => {
          const metaID = `#${listingDataSection.getAttribute('id')}`

          if (currentOption == metaID) {
            listingDataSection.scrollIntoView()

            return
          }

        })
      })
    }

    if (listingAmenities) {
      listingAmenities.classList.add(`has-${listingAmenitiesRow.length}`)
    }

    if (listingAmenitiesReveal) {
      listingAmenitiesReveal.addEventListener('click', function (e) {
        e.preventDefault()

        listingAmenitiesRow.forEach(listingAmenityRow => {
          if (window.getComputedStyle(listingAmenityRow).display === 'none') {
            listingAmenityRow.style.display = 'grid'

            this.style.display = 'none'

            return
          }
        })
      })
    }

    if (listingGallery) {
      listingGallery.classList.add(`has-${listingGalleriesRow.length}`)
    }

    if (listingGalleriesReveal) {
      listingGalleriesReveal.addEventListener('click', function (e) {
        e.preventDefault()

        listingGalleriesRow.forEach(listingGalleryRow => {
          if (listingGalleryRow.style.display !== 'none') {
            listingGalleryRow.style.display = 'grid'

            this.style.display = 'none'

            return
          }
        })
      })
    }

    if ($('.js-hero-carousel').length) {
      $('.js-hero-carousel').slick({
        accessibility: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      })
    }

    if ($('.js-rates-carousel').length) {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        $('.js-rates-carousel').each(function () {
          $(this).slick({
            accessibility: true,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 10000,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Set of Rates"></button>',
            nextArrow: '<button type="button" class="slick-next" aria-label="Next Set of Rates"></button>',
            dots: false,
            fade: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ],
          }).on('setPosition', function (event, slick) {
            slick.$slides.css('height', slick.$slideTrack.height() + 'px')
          })
        })
      }
    }

    if ($('.js-cards-carousel').length) {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        $('.js-cards-carousel').slick({
          accessibility: true,
          adaptiveHeight: true,
          autoplay: true,
          autoplaySpeed: 10000,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Set of Cards"></button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="Next Set of Cards"></button>',
          dots: false,
          fade: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
          ],
        }).on('setPosition', function (event, slick) {
          slick.$slides.css('height', slick.$slideTrack.height() + 'px')
        })
      }
    }

    if (revealHide) {
      revealHide.forEach(reveal => {
        reveal.addEventListener('click', (e) => {
          e.preventDefault()

          const parent = reveal.parentNode
          const parentHide = parent.querySelector('.listing__hide')

          if (reveal.innerHTML === '+ View More') {
            reveal.innerHTML = '&#45; View Less'
          } else {
            reveal.innerHTML = '&#43; View More'
          }

          parentHide.classList.toggle('is-revealed')
        })
      })
    }
    console.log(acfFields);

    // Handles URL referal
    // Handle js popup
    if (Cookies.get('destination')) {
      Cookies.remove('destination');
    }

    console.log('stinky');

    if (jsPopup && !Cookies.get('destination') ) {
      $.fancybox.open({
        autoFocus: false,
        src: '.js-popup',
        type: 'inline',
        btnTpl: fancyboxBtns,
      });

     Cookies.set('destination', 'false', { expires: 7 });
    }

    /*
    const observeMenuItems = (elements) => {
    elements.forEach(element => {
    if (element.isIntersecting) {
    if (element.boundingClientRect.y === element.target.getBoundingClientRect().top) {
    let elementID = element.target.getAttribute('id')

    navListingItems.forEach(navListingItem => {
    if (elementID === navListingItem.children[0].dataset.section.replace(/^#/, '')) {
    navListingItem.classList.add('is-active')

    return
  }

  navListingItem.classList.remove('is-active')
})
}
}
})
}

let observer = new IntersectionObserver(observeMenuItems, {
'threshold': 0.1,
});

const sections = []

navListingItems.forEach(navListingItem => {
let sectionID = navListingItem.children[0].dataset.section.replace(/^#/, '')
let section = document.getElementById(sectionID)

sections.push(section)
})

sections.forEach(section => {
observer.observe(section)
})
*/
},
finalize() {
  // JavaScript to be fired on the home page, after the init JS
},
};



// WEBPACK FOOTER //
// ./scripts/routes/listings.js